import styled from 'styled-components';
import { ToastContainer as ToastContainerBase } from 'react-toastify';

export const ToastContainer = styled(ToastContainerBase)`
  .Toastify__toast {
    width: 300px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #fff;
    background-color: ${props => props.theme.info};
  }
  .Toastify__toast-icon {
    color: #fff;
  }
  .Toastify__toast--error {
    background-color: ${props => props.theme.error};
  }
  .Toastify__toast--warning {
    background-color: ${props => props.theme.warn};
  }
  .Toastify__toast--success {
    background-color: ${props => props.theme.success};
  }
  .Toastify__progress-bar {
    background-color: #fff;
  }
`;
